import SearchResult from "@/views/chat/SearchResult";
import {mapState} from "vuex";

export default {
  name: "EventAsistanceModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Function,
      default: () => {
      }
    },
    onSelectChat: {
      type: Function,
      default: () => {
      }
    },
    onEventActionSelected: {
      type: Function,
      default: () => {
      }
    },
    showCancelOptionsForEvent: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SearchResult
  },
  computed: {
    ...mapState({
      search_results: state => state.Chat.search_results
    })
  },
  watch: {
    show(val) {
      if (val) {
        this.searchText = "";
        this.$store.dispatch("Chat/search", {search: this.searchText, messages: false});
      }
      this.showModal = val;
    },
    searchText(val) {
      if (val) {
        this.showResultSearch = true;
        if (this.searchTimeOut) {
          clearTimeout(this.searchTimeOut);
        }
        this.searchTimeOut = setTimeout(() => {
          this.search();
        }, 500);
      } else {
        this.showResultSearch = false;
      }
    }
  },
  created() {
    this.showModal = this.show;
  },
  data() {
    return {
      showModal: false,
      showResultSearch: false,
      searchTimeOut: null,
      searchText: ""
    }
  },
  methods: {
    search() {
      this.$store.dispatch("Chat/search", {search: this.searchText, messages: false});
    },
    showResultCategory: function (index) {
      if (index === 0) {
        return true
      } else {
        let prev = this.search_results[index - 1].category;
        let actual = this.search_results[index].category;
        return actual !== prev;
      }
    },
    confirm(item) {
      this.onSelectChat(item);
      this.hide();
    },
    hideModal() {
      this.showModal = false;
      this.hide();
    }
  }
}